'use strict';

import React, { Component } from 'react'

import _ from 'lodash'

import { handleChange } from '@/Form/Functions/eventsHandling'

import Layout from '@Layout/BackOffice'

import OrderInfos from '@/OrderInfos'
import Pagination from '@/Pagination'

import FormElement from '@/Form/toolkit/FormElement'
import DatePicker  from '@/Form/V2/DatePicker'

import { isTrue } from '@root/utility'

import Loader    from '@Pure/Loader'
import SearchBar from '@Pure/SearchBar'

import bemit from '@function/bemit'

const { app, qwest, moment } = window;

const radios_class = bemit('c-form-element', ['inline', 'radio-v2']);

export default class OrdersManagementPage extends Component
{
	state =
	{
		orders: [],
		shippings: [],
		actions: [],

		searched:
		{
			value: ''
		},

		status_messages: { },
		selection: [],

		page: 0,
		rows_per_page: 30,
		data_count: 0,

		form_data:
		{
			date_from: moment().subtract(1, 'months').format('YYYY-MM-DD'),

			date_to: moment().format('YYYY-MM-DD'),
		},

		status:
		{
			new: false,
			processing: true,
			completed: false,
			canceled: false
		},

		loading: true
	};

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.resetFunctions();
	}

	componentDidMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.push(
		{
			event: 'documentClick',
			cb: component.handleDocumentClick
		});

		app.push(
		{
			event: 'documentScroll',
			cb: component.stickTable
		});

		app.push(
		{
			event: 'createdShipping',
			cb: component.handleShippingCreation
		});

		app.push(
		{
			event: 'changedProviderOrder',
			cb: component.handleProviderOrderChange
		});

		component.getOrders({ });
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		component.unStickTable();

		component.stick_table    = undefined;
		component.sticky_columns = undefined;
		component.stick_header   = undefined;

		app.delete(
		{
			event: 'documentClick',
			cb: component.handleDocumentClick
		});

		app.delete(
		{
			event: 'documentScroll',
			cb: component.stickTable
		});

		app.delete(
		{
			event: 'createdShipping',
			cb: component.handleShippingCreation
		});

		app.delete(
		{
			event: 'changedProviderOrder',
			cb: component.handleProviderOrderChange
		});
	}

	getOrders = ({ start, end, status={ }, searched, page }) =>
	{
		const component = this, props = this.props, state = this.state;

		const reset =
		[
			start !== undefined,
			end !== undefined,
			searched !== undefined,
			Object.keys(status).length > 0
		]
		.some(condition => condition === true);

		const current_page = reset ? 0 : page !== undefined
		? parseInt(page)
		: parseInt(state.page);

		component.setState({ loading: true });

		const start_date = start !== undefined
		? start
		: state.form_data.date_from;

		const end_date = end !== undefined
		? end
		: state.form_data.date_to;

		const selected_status = Object.keys(state.status)
		.reduce(function (list, name)
		{
			const selected = status[name] !== undefined
			? [true, 'true'].includes(status[name])
			: [true, 'true'].includes(state.status[name]);

			return selected ? list.concat([name]) : list;
		},
		[]);

	// get all orders
		qwest.post('/order/get-all',
		{
			limit: state.rows_per_page,
			skip: state.rows_per_page * current_page,

			status: selected_status,

			date_from: start_date,
			date_to: end_date,
			amount: state.form_data.amount,

			processed_by: isTrue(state.form_data['status[processed_by]']),

			failed_payments: isTrue(state.form_data['payment[failed]']),
			shipping_filter: state.form_data['shipping_filter'],

			searched: searched !== undefined
			? (searched.value || '').trim()
			: (state.searched.value || '').trim(),

			item_number: state.form_data.item_number
		})
		.then(function (xhr, response)
		{
			component.setState(
			{
				orders: response.data || [],
				shippings: response.shippings || [],

				page: current_page,

				data_count: parseInt(response.count) > 0
				? parseInt(response.count)
				: 0,

				loading: false
			});
		})
		.catch(function (error, xhr, response)
		{
			component.setState({ loading: false });

			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	handleProviderOrderChange = (params) =>
	{
		const component = this, props = this.props, state = this.state;

		const { ticket_id } = params;

		let order = state.orders.find(data => data.id === params.order.id);

		if (!order) return;

		let product = order.products.find(function (product)
		{
			if (ticket_id)
			{
				return product.price.ref === params.product.price.ref &&
					product.tickets[ticket_id];
			}

			return product.price.ref === params.product.price.ref;
		});

		if (!product) return;

		if (ticket_id)
		{
			product.tickets[ticket_id].provider_order = params.number;
		}
		else
		{
			product.provider_order = params.number;
		}

		component.setState(
		{
			orders: state.orders
		});
	}

	handleShippingCreation = (data) =>
	{
		const component = this, props = this.props, state = this.state;

		const update = { };

		state.orders
		.filter(order => state['state_error_' + order.id])
		.forEach(order => update['state_error_' + order.id] = undefined);

		state.shippings.push(data.shipping);

		data.completed_orders.forEach(function (id)
		{
			let order = state.orders.find(data => data.id === id);

			if (order) order.status = 'completed';
		});

		component.setState(
		{
			...update,

			shippings: state.shippings,
			selection: [],
			orders: state.orders,
		});
	}

	handleCanceledProduct = (data) =>
	{
		const component = this, props = this.props, state = this.state;

		let order = state.orders.find(order => order.id === data.order_id);

		if (!order) return;

		order.products
		.filter(product => product.price.ref === data.ref)
		.forEach(function (product)
		{
			if (data.ticket_id)
			{
				product.tickets[data.ticket_id].status = 'canceled';
			}
			else
			{
				Object.keys(product.tickets).forEach(function (ticket_id)
				{
					product.tickets[ticket_id].status = 'canceled';
				});
			}
		});

		state.selection.filter(function (item)
		{
			if (data.ticket_id)
			{
				if (item.selected[data.ticket_id])
				{
					item.selected[data.ticket_id] = false;
				}
			}
			else
			{
				let pattern = data.order_id + '--' + data.product_id+ '--' + data.ref;

				Object.keys(item.selected).forEach(function (key)
				{
					if (pattern === key || Object.keys(data.tickets).includes(key))
					{
						item.selected[key] = false;
					}
				});
			}

			let has_selected = Object.keys(item.selected).find(function (key)
			{
				return item.selected[key];
			});

			return has_selected;
		});

		component.setState(
		{
			orders: state.orders,
			selection: state.selection
		});
	}

	handleOrderSelection = (data) =>
	{
		const component = this, props = this.props, state = this.state;

		state.selection = state.selection.filter(function (selected_data)
		{
			return selected_data.order.id !== data.order.id;
		});

		state.selection.push(_.cloneDeep(data));

		component.setState(
		{
			selection: state.selection
		});
	}

	handleFilterChange = (e, data) =>
	{
		const component = this, props = this.props, state = this.state;

		handleChange.bind(component)(e, data);

		if (e === null) return;

		component.setState({ loading: true });

		component.getOrders({ page: 0 });
	}

	handleV2Change = ({ e, value, name }) =>
	{
		const component = this, props = this.props, state = this.state;

		component.handleFilterChange(e, { value, name });
	}

	handleDocumentClick = (source) =>
	{
		const component = this, props = this.props, state = this.state;

		if (!source && state.actions.length > 0)
		{
			return component.setState({ actions: [] });
		}

		if (source && source.label === 'orderManagementActions')
		{
			component.state.actions = component.state.actions
			.filter(function (action)
			{
				return action.type === source.type && action.order.id === source.order_id;
			});

			component.setState({ actions: component.state.actions });
		}
	}

	handleSearch = (value, search) =>
	{
		const component = this, props = this.props, state = this.state;

		const searched =
		{
			value: value,
			data: (search ? search.data : undefined)
		};

		component.setState(
		{
			searched: searched
		});

		window.clearTimeout(component.searchTimeout);

		component.searchTimeout = window.setTimeout(function ()
		{
			component.getOrders({ searched });
		},
		600);
	}

	handleClick = (e, type, data) =>
	{
		const component = this, props = this.props, state = this.state;

		e.stopPropagation();

		const exists = component.state.actions
		.some(action => action.order.id === data.id);

		const update = { actions: component.state.actions.slice(0) };

		if (!exists)
		{
			update.actions.push(
			{
				type: type,
				order: data,
				loading: false
			});

			app.emit('documentClick',
			{
				label: 'orderManagementActions',
				type: type,
				order_id: data.id
			});
		}

		component.setState(update);
	}

	handleAction = (e, action) =>
	{
		const component = this, props = this.props, state = this.state;

		e.stopPropagation();

		app.emit('documentClick',
		{
			label: 'orderManagementAction',
			order: action.order
		});

		let state_action = state.actions.find(function (state_action)
		{
			if (state_action.order.id === action.order.id &&
				state_action.type === action.type)
			{
				state_action.loading = false;

				return true;
			}
		});

		state_action.loading = true;

		component.setState({ actions: state.actions });

		let options = { id: action.order.id };

		if (action.model)
		{
			options.model = action.model;
		}

		qwest.post(action.post, options).then(function (xhr, response)
		{
			state.actions = state.actions.filter(function (state_action)
			{
				if (state_action.order.id === action.order.id &&
					state_action.type === action.type)
				{
					state_action.loading = false;

					return false;
				}

				return true;
			});

			let state_order = state.orders
			.find(order => order.id === action.order.id);

			if (action.post === '/order/validate-payment')
			{
				state_order.paid = 'true';

				if (state_order.status === 'new')
				{
					state_order.status = 'processing';
				}
			}
			else if (action.post === '/order/fail-payment')
			{
				state_order.payment_refused = true;
			}
			else if (action.post === '/order/delete')
			{
				state.orders = state.orders
					.filter(order=> order.id !== state_order.id);
			}
			else if (action.post === '/order/set-status-processing')
			{
				state_order.status = 'processing';
			}
			else if (action.post === '/order/set-status-completed')
			{
				state_order.status = 'completed';
			}

			component.setState(
			{
				orders: state.orders,
				actions: state.actions,
				['state_error_' + options.id]: undefined
			});
		})
		.catch(function (error, xhr, response)
		{
			console.error(error, response);

			state_action.loading = false;

			component.setState({ ['state_error_' + options.id]: response.error });
		});
	}

	handlePageChange = (e, page) =>
	{
		const component = this, props = this.props, state = this.state;

		if (state.loading === true) return;

		component.setState({ page: page });

		component.getOrders({ page: page });
	}

	handleStatusChange = (e, data) =>
	{
		const component = this, props = this.props, state = this.state;

	// Checkbox did mount
		if (e === null) return;

		let name = data.name;

		state.status[name] = [true, 'true'].includes(e.target.checked);

		component.setState(
		{
			status: state.status
		});

		component.getOrders({ status: state.status });
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let days = [];

		let orders = state.loading ?
		(
			<div className="orders__loader_container">
				<Loader className="c-loader" bemit={ ['white', 'bg-primary'] } />
			</div>
		)
		: state.orders.map(function (order)
		{
			let loaders = { }, actions = { };

			['payment', 'status'].forEach(function (name)
			{
				let action = state.actions
				.find(action => action.order.id === order.id && action.type === name);

				if (action && action.loading === true)
				{
					loaders[name] =
					(
						<Loader className="c-loader"
							bemit={ ['white', 'bg-primary'] }
						/>
					);
				}
			});

			let completed_btn;

			if (['canceled', 'completed'].includes(order.status) === false)
			{
				completed_btn =
				(
					<button className="c-order-infos__actions-btn"
						onClick={ function (e)
						{
							component.handleAction(e,
							{
								type: 'status',
								post: '/order/set-status-completed',
								order: order
							});
						}}>
						Passer «&nbsp;en terminée&nbsp;»
					</button>
				);
			}

			let fail_button;

			if (!isTrue(order.paid))
			{
				if (isTrue(order.payment_refused) === false)
				{
					fail_button =
					(
						<button className="c-order-infos__actions-btn" onClick={ function (e)
						{
							component.handleAction(e,
							{
								type: 'payment',
								post: '/order/fail-payment',
								order: order
							});
						}}>
							Passer en «&nbsp;échec&nbsp;»
						</button>
					);
				}

				actions.payment =
				(
					<div className="c-order-infos__actions">
						<button className="c-order-infos__actions-btn" onClick={ function (e)
						{
							component.handleAction(e,
							{
								type: 'payment',
								post: '/order/validate-payment',
								order: order
							});
						}}>
							Valider le paiement
						</button>

						{ fail_button }

						{ loaders['payment'] }
					</div>
				);
			}

			if (!isTrue(order.paid))
			{
				let change_status;

				if (order.status === 'new')
				{
					change_status =
					(
						<button className="c-order-infos__actions-btn" onClick={ function (e)
						{
							component.handleAction(e,
							{
								type: 'status',
								post: '/order/set-status-processing',
								order: order
							});
						}}>
							Passer « en traitement »
						</button>
					);
				}

				if (order.status === 'completed')
				{
					completed_btn = undefined;
				}

				actions.status =
				(
					<div className="c-order-infos__actions">

						{ change_status }

						{ completed_btn }

						{ loaders['status'] }

					</div>
				);
			}
			else if (order.status === 'processing')
			{
				actions.status =
				(
					<div className="c-order-infos__actions">

						{ completed_btn }

						{ loaders['status'] }

					</div>
				);
			}

			Object.keys(actions).forEach(function (name)
			{
				let action = state.actions
				.find(action => action.order.id === order.id && action.type === name);

				if (!action)
				{
					actions[name] = undefined;
				}
			});

			let day = window.moment(order.createdAt).startOf('day').format();
			let show_date = false;

			if (days.includes(day) === false)
			{
				days.push(day);

				show_date = true;
			}

			let shippings = state.shippings.filter(function (shipping)
			{
				let has_order = shipping.products.concat(shipping.items)
				.find(data => data.order_id === order.id);

				return typeof has_order !== 'undefined';
			});

			let output =
			(
				<OrderInfos key={ order.id } data={ order } shippings={ shippings }
					onClick={ component.handleClick }
					admin={ true } open_by_default={ false }
					actions={ actions } show_date={ show_date }
					onSelection={ component.handleOrderSelection }
					state-error={ state['state_error_' + order.id] }
				/>
			);

			return output;
		});

		let header =
		(
			<div className="c-order-infos--header">

				<div className="c-order-infos__order">

					<div className="c-order-infos__number">Commande n°</div>

					<div className="c-order-infos__total-price">Prix total</div>

					<div className="c-order-infos__text">Informations d'achat</div>

					<div className="c-order-infos__processed-by">Traitée</div>

					<div className="c-order-infos__payment">Paiement</div>

					<div className="c-order-infos__status">État</div>

					<div className="c-order-infos__bill">Facture</div>

					<div className="c-order-infos__cancel-product"></div>

				</div>

			</div>
		);

		const shipping_filters =
		(
			<>
				<div className="orders-shipping-filter">

					<div className="orders-shipping-filter__label">
						Livraison&nbsp;:
					</div>

					<div className="orders-shipping-filter__content">

						<div className="c-checkbox-filter">

							<FormElement className={ radios_class }
								name="shipping_filter" type="radio"
								data={ state.form_data }
								label="Synergies"
								status={ state.status_messages }
								onChange={ component.handleFilterChange }
								radio_value="synergies"
							/>

						</div>

						<div className="c-checkbox-filter">

							<FormElement className={ radios_class }
								name="shipping_filter" type="radio"
								data={ state.form_data }
								label="Électronique"
								status={ state.status_messages }
								onChange={ component.handleFilterChange }
								radio_value="online"
							/>

						</div>

						<div className="c-checkbox-filter">

							<FormElement className={ radios_class }
								name="shipping_filter" type="radio"
								data={ state.form_data }
								label="Domicile/CE"
								status={ state.status_messages }
								onChange={ component.handleFilterChange }
								radio_value="carrier"
							/>

						</div>

					</div>

				</div>
			</>
		);

		var output =
		(
			<Layout history={ props.history } page_title="Gestion des commandes">

				<div className="page-content orders-management-page">

					<div className="u-negative-margins">

						<div className="o-grid-2 u-margin-bottom-15
							order-management-filters">

							<div className="o-grid__item u-flex">

								<SearchBar hide_btn={ true }
									placeholder="Recherche..."
									handleChange={ component.handleSearch }
									value={ state.searched.value }
								/>

								<FormElement name="status[processed_by]"
									type="checkbox" data={ state.form_data }
									onChange={ component.handleFilterChange }
									status={ state.status_messages }
									label="Traitée"
								/>

								<FormElement name="payment[failed]"
									type="checkbox" data={ state.form_data }
									onChange={ component.handleFilterChange }
									status={ state.status_messages }
									label="Echec"
								/>
							</div>

							<div className="o-grid__item">

								<FormElement name="new"
									type="checkbox" data={ state.status }
									onChange={ component.handleStatusChange }
									status={ state.status_messages }
									label="En attente"
								/>

								<FormElement name="processing"
									type="checkbox" data={ state.status }
									onChange={ component.handleStatusChange }
									status={ state.status_messages }
									label="En traitement"
								/>

								<FormElement name="completed"
									type="checkbox" data={ state.status }
									onChange={ component.handleStatusChange }
									status={ state.status_messages }
									label="Terminée"
								/>

								<FormElement name="canceled"
									type="checkbox" data={ state.status }
									onChange={ component.handleStatusChange }
									status={ state.status_messages }
									label="Annulée"
								/>

							</div>

							<div className="o-grid__item u-flex u-gap-10">
								<SearchBar hide_btn={ true }
									placeholder="Montant facturé (ex 40.5)"
									handleChange={ component.handleFilterChange }
									value={ state.form_data.amount }
									name="amount"
								/>

								<SearchBar hide_btn={ true }
									placeholder="N° de billet"
									handleChange={ component.handleFilterChange }
									value={ state.form_data.item_number }
									name="item_number"
								/>
							</div>

							<div className="o-grid__item">
								{ shipping_filters }
							</div>

							<div className="o-grid__item u-flex u-items-end u-gap-10">
								<DatePicker name="date_from" label="Du"
									onChange={ component.handleV2Change }
									value={ state.form_data.date_from }
									bemit={ ['50%'] }
									error={ state.status_messages?.date_from?.error }
								/>

								<DatePicker name="date_to" label="Au"
									onChange={ component.handleV2Change }
									value={ state.form_data.date_to }
									bemit={ ['50%'] }
									error={ state.status_messages?.date_to?.error }
								/>
							</div>

							<div className="o-grid__item" />

						</div>

					</div>

					<Pagination current={ state.page } total={ state.data_count }
						items-per-page={ state.rows_per_page }
						onChange={ component.handlePageChange }
					/>

					<div className="u-text-right u-margin-top-15 u-margin-bottom-15">

						<button className="c-btn" id="create-shipping-button"
							onClick={ function (e)
							{
								app.emit('open__ShippingModal',
								{
									selection: state.selection,
									onValidate: function (response)
									{
										component.setState(
										{
											selection: []
										});
									}
								});
							} }>
							Traiter les commandes sélectionnées
						</button>

					</div>

					<div id="sticky-order-management">

						{ header }

						{ orders }

						<div className="u-text-right
							u-margin-top-20 u-margin-bottom-20">

							<a className="c-btn u-margin-left-10 u-margin-bottom-10"
								target="_blank"type="text/csv"
								href="/export/export-commandes-recherche">
								Exporter la recherche de la référence
							</a>

						</div>

					</div>

				</div> { /* /page-content */ }

			</Layout>
		);

		return output;
	}

	stickTable = () =>
	{
		const component = this, props = this.props, state = this.state;

		let stick_header = component.stick_header;
		let create_order = component.stick_button;
		let stick_table  = component.stick_table;

		if (!component.stick_table)
		{
			create_order = document.getElementById('create-shipping-button');
			stick_table  = document.getElementById('sticky-order-management');

			stick_header = stick_table.querySelector('.c-order-infos--header');

			component.stick_table  = stick_table;
			component.stick_header = stick_header;
			component.stick_button = create_order;
		}

		stick_table.style.top = (47+15) + (36+15) + 'px';

		let top_distance = stick_table.getBoundingClientRect().top;

		let distance = 287;

		if (stick_header.classList.contains('js-sticky')) distance = 280;

		if (top_distance < distance)
		{
			stick_header.style.width = stick_header.getBoundingClientRect()
			.width + 'px';

			window.requestAnimationFrame(function ()
			{
				stick_header.classList.add('js-sticky');
				create_order.classList.add('js-sticky');
			});
		}
		else
		{
			component.unStickTable();
		}
	}

	unStickTable = () =>
	{
		const component = this, props = this.props, state = this.state;

		let create_order = component.stick_button;
		let stick_header = component.stick_header;
		let stick_table  = component.stick_table;

		if (!stick_table)
		{
			create_order = document.getElementById('create-shipping-button');
			stick_table  = document.getElementById('sticky-order-management');

			stick_header = stick_table.querySelector('.c-order-infos--header');

			component.stick_table  = stick_table;
			component.stick_header = stick_header;
			component.stick_button = create_order;
		}

		stick_table.style.top = '';

		stick_header.classList.remove('js-sticky');
		stick_header.style.width = '';

		create_order.classList.remove('js-sticky');
	}
}
